import { useSyncExternalStore } from "react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { closeViewer, getViewer, subscribeViewer } from "../../utils/documentViewer";
import Modal from "./Modal";
import Button from "./Button";
import { Loading } from "./Spinner";

const download = ({ url, fileName }) => Object.assign(document.createElement("a"), { href: url, download: fileName }).click();

// Only images and PDFs are shown inline: anything else rendered from a blob could run in the app's origin
function Preview({ viewer, title }) {
  if (viewer.status === "loading") return <Loading label="Opening the document…" className="h-[70vh]" />;
  if (viewer.type.startsWith("image/")) {
    return <img src={viewer.url} alt={title} className="mx-auto max-h-[70vh] object-contain" />;
  }
  if (viewer.type === "application/pdf") {
    return <iframe src={viewer.url} title={title} className="h-[70vh] w-full rounded-md border border-slate-200" />;
  }
  return (
    <div className="flex h-[40vh] flex-col items-center justify-center gap-2 text-center">
      <p className="font-semibold text-slate-900">No preview for this file</p>
      <p className="text-sm text-slate-500">Download it to open it on your device.</p>
    </div>
  );
}

// Mounted once at the root; opened through showDocument
export default function DocumentViewer() {
  const viewer = useSyncExternalStore(subscribeViewer, getViewer);
  const title = viewer?.fileName || "Document";
  return (
    <Modal
      open={!!viewer}
      onClose={closeViewer}
      title={title}
      size="full"
      footer={
        viewer?.status === "ready" && (
          <>
            <Button variant="ghost" size="sm" onClick={closeViewer}>
              Close
            </Button>
            <Button size="sm" icon={<ArrowDownTrayIcon className="h-4 w-4" />} onClick={() => download(viewer)}>
              Download
            </Button>
          </>
        )
      }
    >
      {viewer && <Preview viewer={viewer} title={title} />}
    </Modal>
  );
}
